interface IUTMParams {
  utm_source: string;
  utm_medium: string;
  utm_campaign: string;
  utm_content: string;
}

export function getExtractedUTMParamsFromURL(): IUTMParams {
  const urlParams = new URLSearchParams(window.location.search);

  const mockedUTMParams: IUTMParams = {
    utm_source: '',
    utm_medium: '',
    utm_campaign: '',
    utm_content: '',
  };

  Object.keys(mockedUTMParams).forEach((param) => {
    const value = urlParams.get(param);

    if (value !== null) {
      mockedUTMParams[param as keyof IUTMParams] = value;
    }
  });

  return mockedUTMParams;
}
